import { RouterView } from "vue-router";

export const studentsRoute = {
  path: ":menu/students",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/students/list/index.vue"),
    },
  ],
};
